import React from 'react';
import { UpsertMissionMapProps } from './types';
import { useSelector } from 'react-redux';
import { selectSidebarType } from './redux';
import { MissionIdParams } from '@src/core/entities';
import { useParams } from 'react-router-dom';
import { CreateRouteMap, SelectDroneMap, UpdateRouteMap } from './maps';
import { SidebarType } from './entities';

const UpsertMissionMap: React.FC<UpsertMissionMapProps> = () => {
  const sidebarType = useSelector(selectSidebarType);
  const params = useParams<MissionIdParams>();

  if (params.missionId) {
    return <UpdateRouteMap />;
  }

  if (sidebarType === SidebarType.SELECT_DRONE) {
    return <SelectDroneMap />;
  }

  if (sidebarType === SidebarType.ENTER_ROUTE_FORM) {
    return <CreateRouteMap />;
  }

  return null;
};

export default UpsertMissionMap;